import { jsx as _jsx } from "react/jsx-runtime";
import Portal from 'web-app/react/components/portals/portal';
import { PortalRootId } from 'web-app/react/components/portals/constants';
export const renderStyle = (css) => () => (_jsx(Portal, { rootId: PortalRootId.contractPortalRoot, children: _jsx("style", { type: "text/css", children: css.join('') }) }));
